import React from "react";
import * as Icons from "react-feather";

export default function ResellerReport() {
   return (
      <>
         <div className="col-span-12 mt-8">
            <div className="intro-y flex items-center h-10">
               <h2 className="text-lg font-medium truncate mr-5">
                  گزارش کلی فروش توسط شما
               </h2>
               <a
                  href="javascript:;"
                  className="mr-auto flex items-center text-theme-1 dark:text-theme-10"
               >
                  {" "}
                  <Icons.RefreshCcw className="w-4 h-4 ml-3"/> تازه سازی{" "}
               </a>
            </div>
            <div className="grid grid-cols-12 gap-6 mt-5">
               <div className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                  <div className="report-box zoom-in">
                     <div className="box p-5">
                        <div className="flex">
                           <Icons.User className="report-box__icon text-theme-10"/>
                           <div className="mr-auto">
                              <div
                                 className="report-box__indicator bg-theme-9 tooltip cursor-pointer"
                                 title={"%۱۰" + " بیشتر از ماه پیش"}
                              >
                                 {" "}
                                 ۱۰٪ <Icons.ChevronUp className="w-4 h-4 ml-0.5"/>{" "}
                              </div>
                           </div>
                        </div>
                        <div className="text-3xl font-medium leading-8 mt-6">۱۲۰۰</div>
                        <div className="text-base text-gray-600 mt-1">تعدا کاربران</div>
                     </div>
                  </div>
               </div>
               <div className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                  <div className="report-box zoom-in">
                     <div className="box p-5">
                        <div className="flex">
                           <Icons.ShoppingBag className="report-box__icon text-theme-10"/>
                           <div className="mr-auto">
                              <div
                                 className="report-box__indicator bg-theme-6 tooltip cursor-pointer"
                                 title={"%۱۰" + " بیشتر از ماه پیش"}
                              >
                                 {" "}
                                 ۱۰٪ <Icons.ChevronDown className="w-4 h-4 ml-0.5"/>{" "}
                              </div>
                           </div>
                        </div>
                        <div className="text-3xl font-medium leading-8 mt-6">۳۶۰۰۰</div>
                        <div className="text-base text-gray-600 mt-1">تعداد فروش</div>
                     </div>
                  </div>
               </div>
               <div className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                  <div className="report-box zoom-in">
                     <div className="box p-5">
                        <div className="flex">
                           <Icons.DollarSign className="report-box__icon text-theme-10"/>
                           <div className="mr-auto">
                              <div
                                 className="report-box__indicator bg-theme-9 tooltip cursor-pointer"
                                 title={"%۱۰" + " بیشتر از ماه پیش"}
                              >
                                 {" "}
                                 ۱۰٪ <Icons.ChevronUp className="w-4 h-4 ml-0.5"/>{" "}
                              </div>
                           </div>
                        </div>
                        <div className="text-3xl font-medium leading-8 mt-6">۸۹۶ میلیون ريال</div>
                        <div className="text-base text-gray-600 mt-1">مبلغ کل فروش</div>
                     </div>
                  </div>
               </div>
               <div className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                  <div className="report-box zoom-in">
                     <div className="box p-5">
                        <div className="flex">
                           <Icons.DollarSign className="report-box__icon text-theme-10"/>
                           <div className="mr-auto">
                              <div
                                 className="report-box__indicator bg-theme-9 tooltip cursor-pointer"
                                 title={"%۱۰" + " بیشتر از ماه پیش"}
                              >
                                 {" "}
                                 ۱۰٪ <Icons.ChevronUp className="w-4 h-4 ml-0.5"/>{" "}
                              </div>
                           </div>
                        </div>
                        <div className="text-3xl font-medium leading-8 mt-6">
                           ۱۴/۵۰۰/۰۰۰
                        </div>
                        <div className="text-base text-gray-600 mt-1">میانگین فروش روزانه</div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="box col-span-12 overflow-auto lg:overflow-visible">
            <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
               <table className="table table-report -mt-2">
                  <thead>
                  <tr>
                     <th className="whitespace-nowrap text-center">شناسه</th>
                     <th className="whitespace-nowrap text-center">عنوان محصول</th>
                     <th className="whitespace-nowrap text-center">خریدار</th>
                     <th className="whitespace-nowrap text-center">قیمت محصول</th>
                     <th className="whitespace-nowrap text-center">کد بلیت</th>
                     <th className="whitespace-nowrap text-center">تاریخ فروش</th>
                  </tr>
                  </thead>
                  {/*{load && <Loading/>}*/}
                  {/*{list && !list.length > 0 && <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>}*/}
                  <tbody>
                  {/*{!load && list && list.length > 0 && list.map((item) => (*/}
                  <tr className="intro-x">
                     <td className="w-16 text-center">
                        {/*{item.id}*/}1
                     </td>
                     <td>
                        <div className="flex justify-center">
                           خانه به دوش
                        </div>
                     </td>
                     <td>
                        <p className="font-medium whitespace-nowrap text-center">حسین گلی</p>
                     </td>
                     <td>
                        <p className="font-medium whitespace-nowrap text-center">459000 ريال</p>
                     </td>
                     <td>
                        <p className="font-medium whitespace-nowrap text-center">HK-1957646</p>
                     </td>
                     <td>
                        <p className="font-medium whitespace-nowrap text-center">1400/11/11</p>
                     </td>
                  </tr>
                  {/*))}*/}
                  </tbody>
               </table>
            </div>
         </div>
      </>
   );
}
